<template>
  <div class="ws-dash-serv-metrics">
    <article class="ws-dash-serv-metrics__block ws-dash-serv-metrics__block--clientes">
      <header class="ws-dash-serv-metrics__head">
        <div class="ws-dash-serv-metrics__title-wrap">
          <span class="ws-dash-serv-metrics__icon" aria-hidden="true">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
          </span>
          <h3 class="ws-dash-serv-metrics__title">{{ t('workspaceDashboard.servicos.blocks.clientes') }}</h3>
        </div>
        <RouterLink :to="clientesLink" class="ws-dash-serv-metrics__link">
          {{ t('workspaceDashboard.servicos.open') }}
        </RouterLink>
      </header>
      <div class="ws-dash-serv-metrics__grid ws-dash-serv-metrics__grid--2">
        <div class="ws-dash-serv-metrics__kpi">
          <span class="ws-dash-serv-metrics__label">{{ t('workspaceDashboard.servicos.totalClientes') }}</span>
          <span v-if="loading" class="ws-dash-serv-metrics__skeleton" />
          <strong v-else class="ws-dash-serv-metrics__value">{{ formatCount(clientes.total) }}</strong>
        </div>
        <div class="ws-dash-serv-metrics__kpi">
          <span class="ws-dash-serv-metrics__label">{{ t('workspaceDashboard.servicos.novosNoMes') }}</span>
          <span v-if="loading" class="ws-dash-serv-metrics__skeleton" />
          <strong v-else class="ws-dash-serv-metrics__value">{{ formatCount(clientes.novosNoMes) }}</strong>
        </div>
      </div>
    </article>

    <article class="ws-dash-serv-metrics__block ws-dash-serv-metrics__block--financeiro">
      <header class="ws-dash-serv-metrics__head">
        <div class="ws-dash-serv-metrics__title-wrap">
          <span class="ws-dash-serv-metrics__icon" aria-hidden="true">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
          </span>
          <h3 class="ws-dash-serv-metrics__title">{{ t('workspaceDashboard.servicos.blocks.financeiro') }}</h3>
        </div>
        <RouterLink :to="financeiroLink" class="ws-dash-serv-metrics__link">
          {{ t('workspaceDashboard.servicos.open') }}
        </RouterLink>
      </header>
      <div class="ws-dash-serv-metrics__grid ws-dash-serv-metrics__grid--4">
        <div class="ws-dash-serv-metrics__kpi">
          <span class="ws-dash-serv-metrics__label">{{ t('workspaceDashboard.servicos.aEntrar') }}</span>
          <span v-if="loading" class="ws-dash-serv-metrics__skeleton" />
          <MoneyAmount v-else class="ws-dash-serv-metrics__value ws-dash-serv-metrics__value--money" :value="aEntrar" size="sm" />
        </div>
        <div class="ws-dash-serv-metrics__kpi">
          <span class="ws-dash-serv-metrics__label">{{ t('workspaceDashboard.servicos.pendente') }}</span>
          <span v-if="loading" class="ws-dash-serv-metrics__skeleton" />
          <MoneyAmount v-else class="ws-dash-serv-metrics__value ws-dash-serv-metrics__value--money" :value="pendente" size="sm" />
        </div>
        <div class="ws-dash-serv-metrics__kpi">
          <span class="ws-dash-serv-metrics__label">{{ t('workspaceDashboard.servicos.atrasado') }}</span>
          <span v-if="loading" class="ws-dash-serv-metrics__skeleton" />
          <MoneyAmount v-else class="ws-dash-serv-metrics__value ws-dash-serv-metrics__value--money" :value="atrasado" size="sm" />
        </div>
        <div class="ws-dash-serv-metrics__kpi">
          <span class="ws-dash-serv-metrics__label">{{ t('workspaceDashboard.servicos.previsaoProximoMes') }}</span>
          <span v-if="loading" class="ws-dash-serv-metrics__skeleton" />
          <MoneyAmount v-else class="ws-dash-serv-metrics__value ws-dash-serv-metrics__value--money" :value="previsaoProximoMes" size="sm" />
        </div>
      </div>
    </article>

    <article class="ws-dash-serv-metrics__block ws-dash-serv-metrics__block--agenda">
      <header class="ws-dash-serv-metrics__head">
        <div class="ws-dash-serv-metrics__title-wrap">
          <span class="ws-dash-serv-metrics__icon" aria-hidden="true">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
            </svg>
          </span>
          <h3 class="ws-dash-serv-metrics__title">{{ t('workspaceDashboard.servicos.blocks.agenda') }}</h3>
        </div>
        <RouterLink :to="agendaLink" class="ws-dash-serv-metrics__link">
          {{ t('workspaceDashboard.servicos.open') }}
        </RouterLink>
      </header>
      <div class="ws-dash-serv-metrics__grid ws-dash-serv-metrics__grid--2">
        <div class="ws-dash-serv-metrics__kpi">
          <span class="ws-dash-serv-metrics__label">{{ t('workspaceDashboard.servicos.hoje') }}</span>
          <span v-if="loading" class="ws-dash-serv-metrics__skeleton" />
          <strong v-else class="ws-dash-serv-metrics__value">{{ formatCount(agenda.hoje) }}</strong>
        </div>
        <div class="ws-dash-serv-metrics__kpi">
          <span class="ws-dash-serv-metrics__label">{{ t('workspaceDashboard.servicos.amanha') }}</span>
          <span v-if="loading" class="ws-dash-serv-metrics__skeleton" />
          <strong v-else class="ws-dash-serv-metrics__value">{{ formatCount(agenda.amanha) }}</strong>
        </div>
        <div class="ws-dash-serv-metrics__kpi" style="grid-column: 1 / -1;">
          <span class="ws-dash-serv-metrics__label">{{ t('workspaceDashboard.servicos.proximos7') }}</span>
          <span v-if="loading" class="ws-dash-serv-metrics__skeleton" />
          <strong v-else class="ws-dash-serv-metrics__value">{{ formatCount(agenda.proximos7) }}</strong>
        </div>
      </div>
    </article>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import MoneyAmount from '@/components/MoneyAmount.vue'

const props = defineProps({
  workspaceId: { type: [String, Number], required: true },
  loading: { type: Boolean, default: false },
  clientes: {
    type: Object,
    default: () => ({ total: 0, novosNoMes: 0 })
  },
  financeiro: {
    type: Object,
    default: () => ({ kpis: {}, forecast: {} })
  },
  agenda: {
    type: Object,
    default: () => ({ hoje: 0, amanha: 0, proximos7: 0 })
  }
})

const { t } = useI18n()

const basePath = computed(() => `/workspace/${props.workspaceId}`)

const clientesLink = computed(() => `${basePath.value}/clientes`)
const financeiroLink = computed(() => `${basePath.value}/financeiro`)
const agendaLink = computed(() => `${basePath.value}/agenda`)

const mapMoney = (block) => Number(block?.valor) || 0

const aEntrar = computed(() => mapMoney(props.financeiro?.forecast?.mesAtual?.previsaoEntrada))
const pendente = computed(() => mapMoney(props.financeiro?.kpis?.totalAberto))
const atrasado = computed(() => mapMoney(props.financeiro?.kpis?.atrasados))
const previsaoProximoMes = computed(() => mapMoney(props.financeiro?.forecast?.proximoMes?.previsaoRecebiveis))

const formatCount = (value) => {
  if (value === null || value === undefined || value === '') return '—'
  return Number(value).toLocaleString()
}
</script>

<style src="@/assets/styles/workspace-dashboard-servicos.css"></style>
